(() => {
  if (window.JoyOffers) return;
  const root = window.Shopify?.routes?.root || '/';
  const code = 'CALENDAR-EXTRA40';
  const config = () => window.jtOfferText || {};
  const post = async (path, data) => {
    const response = await fetch(root + path, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || config().error);
    return result;
  };
  const cart = async () => {
    const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(config().error);
    return response.json();
  };
  const selected = form => Array.from(form.querySelectorAll('[data-jt-extra]:checked')).slice(0,1).map(input => ({id:Number(input.dataset.jtExtra),quantity:1}));
  const applyDiscount = async () => {
    const current = await cart();
    const codes = new Set((current.discount_codes || []).map(item => item.code));
    for (const application of current.cart_level_discount_applications || []) {
      if (application.type === 'discount_code') codes.add(application.title);
    }
    for (const line of current.items || []) {
      for (const allocation of line.line_level_discount_allocations || []) {
        if (allocation.discount_application?.type === 'discount_code') codes.add(allocation.discount_application.title);
      }
    }
    codes.add(code);
    return post('cart/update.js', {discount:Array.from(codes).join(',')});
  };
  const refresh = async (result, source) => {
    const current = await cart();
    if (window.theme?.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{source,cart:current});
    document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:result}}));
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:current}}));
    document.querySelectorAll('cart-count').forEach(count => {count.textContent=current.item_count;count.hidden=current.item_count===0;count.setAttribute('aria-label',current.item_count+' items');});
    if (document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
    else window.location.assign(root+'cart');
    return current;
  };
  const add = async (items, extra, control, container) => {
    if (control.disabled) return;
    control.disabled=true;
    control.setAttribute('aria-busy','true');
    const error=container.querySelector('[data-jt-offer-error]');
    if(error){error.hidden=true;error.textContent='';}
    let accepted=false;
    try {
      const result=await post('cart/add.js',{items});
      accepted=true;
      if(extra) await applyDiscount();
      await refresh(result,'jt-bundle-offer');
    } catch (problem) {
      if (accepted) window.location.assign(root+'cart');
      else if(error){error.textContent=problem.message || config().error;error.hidden=false;}
    } finally {
      control.disabled=false;
      control.removeAttribute('aria-busy');
    }
  };
  window.JoyOffers={selected,applyDiscount,refresh};
  document.addEventListener('change', event => {
    const input=event.target.closest('[data-jt-extra]');
    if(input?.checked) input.closest('[data-jt-extras]').querySelectorAll('[data-jt-extra]').forEach(other => {if(other!==input) other.checked=false;});
  });
  document.addEventListener('click', event => {
    const button=event.target.closest('[data-jt-offer-add]');
    if(!button) return;
    event.preventDefault();
    add([{id:Number(button.dataset.jtOfferAdd),quantity:1}],true,button,button.closest('[data-jt-extras]'));
  });
  document.addEventListener('submit', event => {
    const form=event.target.closest('.jt-trio-form');
    if(!form) return;
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]');
    add([{id:Number(new FormData(form).get('id')),quantity:1}],false,button,form);
  });
})();
